var consts = {
    // MainUrl: "http://localhost:3000",
    // BackendUrl: "http://localhost:3500/kaaviapi",
    // socketUrl: 'http://localhost:3500',
    MainPair: "XRP_USDT",
    MainUrl: "https://kaaviex.com/",
    BackendUrl: "https://kaaviex.com/kaaviapi",
    socketUrl: 'https://kaaviex.com',
}
export default consts;